module.exports = __webpack_public_path__ + "img/5-5.9a0c717e.png";